import React, { Component } from "react"
import ButtonsForm from "../../../components/ButtonsForm"
import { Link, Redirect } from 'react-router-dom'
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import helper from "../../../utils/helper"
import Select from '../../../components/Select'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import { getClientesModulo, createOptionsClientes } from "../../../services/clientes"
import ConfirmDelete from "../../../components/ConfirmDelete"

class Form extends Component {
    userInfo = auth.getUserInfo()

    state = {
        detalhes: { 
            cliente: null, 
            nome: null, 
            descricao: null, 
            tipo_plano: { label: "Assinatura", value: "assinatura" },
            cobranca_por: { label: "Mês", value: "mes" }, 
            frequencia_cobranca: 1, 
            valor: "R$ 0,00", 
            quantidade_de_mensagem: 0, 
            quantidade_de_dados_trafegados: 0, 
            quantidade_de_dispositivo: 0,
            valor_mensagem: "R$ 0,00",
            valor_dados_trafegados: "R$ 0,00",
            valor_dispositivo: "R$ 0,00"
        },
        fieldsChecked: { quantidade_de_mensagem: false, quantidade_de_dados_trafegados: false, quantidade_de_dispositivo: false },
        cooldown: false,
        redirect: false,
        path: "",
        tab: 0,
        clientes: [],
        optionsClientes: [],
        optionsCobranca: [
            { label: "Minuto", value: "minuto" },
            { label: "Hora", value: "hora" },
            { label: "Dia", value: "dia" },
            { label: "Mês", value: "mes" },
            { label: "Ano", value: "ano" }
        ],
        tipoPlano: [
            { label: "Assinatura", value: "assinatura" },
            { label: "Sob Demanda", value: "sob_demanda" }
        ],
        info: {
            tipo_plano_sob_demanda: "A fatura é gerada cada vez que a quantidade de mensagens, dados trafegados ou dispositivos é atingida.",
            tipo_plano_assinatura: "A fatura é gerada a cada período definido, com limite máximo de mensagens, dados trafegados ou dispositivos. Quando o limite é atingido, o acesso do cliente é limitado.",
            dados_trafegados: "A quantidade de dados trafegados é calculada em megabytes.",
            cobranca_por: "Defina o tipo de período de cobrança. Isso define o período de cobrança do plano.",
            frequencia_cobranca: "Defina um ciclo diferente de cobrança. Por exemplo, se a cobrança for por mês e a frequência for 2, a cobrança será feita a cada 2 meses.",
            valor: "Defina o valor do plano. Isso define o valor do plano por período de cobrança."
        }
    }

    componentDidMount = async () => {
        await getClientesModulo('lns').then((clientes) => this.setState({ optionsClientes: createOptionsClientes(clientes) }) )

        if (this.props.match.params.id) {
            this.getData()
        } 
    }

    getData = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/planos/' + this.props.match.params.id + '/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            const clientes = this.state.optionsClientes.filter((item) => {if(data.cliente.includes(item.value)) return item})

            let tipo_plano_backend = data.extra_fields && data.extra_fields.tipo_plano
            let tipo_plano = this.state.tipoPlano.find((item) => item.value == tipo_plano_backend)
            if (!tipo_plano) {
                tipo_plano = { label: "Assinatura", value: "assinatura" }
            }

            this.setState({ 
                clientes,
                detalhes: { 
                    cliente: null,
                    nome: data.nome, 
                    descricao: data.descricao,
                    tipo_plano: tipo_plano,
                    cobranca_por: this.state.optionsCobranca.find((item) => item.value == data.extra_fields.cobranca_por) ?? { label: "Mês", value: "mes" },
                    frequencia_cobranca: data.extra_fields?.frequencia_cobranca,
                    valor: helper.formatMoney(data.valor), 
                    quantidade_de_mensagem: data.quantidade_de_mensagem,
                    quantidade_de_dados_trafegados: data.quantidade_de_dados_trafegados,
                    quantidade_de_dispositivo: data.quantidade_de_dispositivo,
                    valor_mensagem: helper.formatMoney(data.extra_fields?.valor_mensagem),
                    valor_dados_trafegados: helper.formatMoney(data.extra_fields?.valor_dados_trafegados),
                    valor_dispositivo: helper.formatMoney(data.extra_fields?.valor_dispositivo)
                },
                fieldsChecked: data.extra_fields?.fieldsChecked
            })
        })
    }

    handleChange = (field, value, isNumber = false, formatMoney = false) => {
        const detalhes = Object.assign({}, this.state.detalhes)
        const span = document.getElementById(`validacao-${field}`)

        if(isNumber){
           value = helper.justNumbers(value)
        }

        if(formatMoney) {
            value = helper.formatMoney(value)
        }

        detalhes[field] = value
        
        if(span) {
            span.innerHTML = ""
        }

        if(field === "tipo_plano") {
            detalhes.quantidade_de_mensagem = 0
            detalhes.quantidade_de_dados_trafegados = 0
            detalhes.quantidade_de_dispositivo = 0
            detalhes.valor_mensagem = "R$ 0,00"
            detalhes.valor_dados_trafegados = "R$ 0,00"
            detalhes.valor_dispositivo = "R$ 0,00"
        }

        this.setState({ detalhes })
    }

    handleChangeFieldsChecked = (field, value) => {
        const fieldsChecked = Object.assign({}, this.state.fieldsChecked)
        fieldsChecked[field] = value
        this.setState({fieldsChecked})
    }

    modalInfo = (message) => {
        helper.dispatchEvent("showAviso", {
            message: message,
            callbackClose: () => {}
        })
    }

    saveAction = (novoCadastro) => {
        const { detalhes, fieldsChecked } = this.state

        this.setState({ cooldown: true })

        let requestURL = ""
        let verb = ""

        if (this.props.match.params.id) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/planos/' + this.props.match.params.id + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/planos/'
            verb = 'post'
        }

        let data = {
            cliente: this.state.clientes.map((item) => item.value),
            nome: detalhes.nome,
            descricao: detalhes.descricao,
            extra_fields: {
                tipo_plano: detalhes?.tipo_plano?.value,
                frequencia_cobranca: detalhes.frequencia_cobranca,
                cobranca_por: detalhes.cobranca_por.value,
                fieldsChecked
            }
        }

        for(let i in fieldsChecked) {
            data[i] = fieldsChecked[i] ? detalhes[i] : 0
        }

        if(detalhes.valor){
            let valor = detalhes.valor.replace("R$", "").replace(" ", "").replaceAll(".", "").replaceAll(",", ".")
            data["valor"] = Number(valor)
            data['extra_fields']["valor_mensagem"] = detalhes.valor_mensagem?.replace("R$", "").replace(" ", "").replaceAll(".", "").replaceAll(",", ".")
            data['extra_fields']["valor_dados_trafegados"] = detalhes.valor_dados_trafegados?.replace("R$", "").replace(" ", "").replaceAll(".", "").replaceAll(",", ".")
            data['extra_fields']["valor_dispositivo"] = detalhes.valor_dispositivo?.replace("R$", "").replace(" ", "").replaceAll(".", "").replaceAll(",", ".")
        }

        axios({
            method: verb,
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {
                helper.dispatchEvent("showAviso", {
                    message: `Plano ${verb === "post" ? "criado" : "editado"} com sucesso.`,
                    callback: () => this.setState({ redirect: true, path: "/lns/planos" }),
                    callbackClose: verb === "post" ?
                        () => {
                            window.location.href = `/lns/planos/${res.data.id}/editar`
                            setTimeout(() => { window.location.reload() }, 1000)
                        }
                    : null
                })
            }
        }).catch((error) => {
            let erros = Object.entries(error.response.data)

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    let span = document.querySelector(`#validacao-${erros[i][0]}`)
                    if (span) span.innerHTML = erros[i][1]
                }
            }
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    handleTab = (index) => this.setState({ tab: index })

    addCliente = () => {
        const detalhes = Object.assign({}, this.state.detalhes)
        const clientes = [...this.state.clientes]
        const estaContido = clientes.find((item) => item.value === detalhes.cliente.value)

        if(estaContido) {
            let span = document.querySelector(`#validacao-cliente`)
            span.innerHTML = "Cliente já adicionado."
            return
        }

        clientes.push(detalhes.cliente)
        detalhes.cliente = null
        this.setState({ detalhes, clientes })
    }

    deletarCliente = (keyDelete) => {
        let clientes = [...this.state.clientes]
        clientes = clientes.filter((item, index) => index !== keyDelete)
        this.setState({ clientes })
    }
    
    render() {
        const { detalhes, tab, clientes, fieldsChecked, info } = this.state
        const edit = this.props.match.params.id ? true : false


        if (this.state.redirect) {
            return <Redirect to={this.state.path} />
        }

        return (
            <div>
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        {this.props.match.params.id ? <h4>Editar Plano</h4> : <h4>Novo Plano</h4>}
                        <div className="gray-background">
                            <i className="las la-file-invoice-dollar la-2x"></i>
                        </div>
                    </span>
                </div>

                <Tabs className="tabs-style" selectedIndex={this.state.tab} onSelect={(i) => this.handleTab(i)}>
                    <TabList>
                        <Tab>Geral</Tab>
                        <Tab>Clientes</Tab>
                    </TabList>
                    
                    <TabPanel>
                        <div className="hdv-form-default">
                            <div className="row">
                                <div className="col-md-4">
                                    <label className='required' htmlFor="nome">Nome</label>
                                    <input
                                        type='text'
                                        value={detalhes.nome ?? ""}
                                        id="nome"
                                        onChange={(e) => this.handleChange("nome", e.target.value)}
                                    />
                                    <span id='validacao-nome'></span>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="descricao">Descrição</label>
                                    <input
                                        type='text'
                                        value={detalhes.descricao ?? ""}
                                        id="descricao"
                                        onChange={(e) => this.handleChange("descricao", e.target.value)}
                                    />
                                    <span id='validacao-descricao'></span>
                                </div>
                                <div className="col-md-4">
                                    <div className="d-flex align-items-center">
                                        <label className='required'>
                                            Tipo de Plano
                                            &nbsp;
                                            {
                                                detalhes.tipo_plano?.value === "sob_demanda" ?
                                                    <i className="las la-info-circle" data-toggle="tooltip" data-placement="top" title={info.tipo_plano_sob_demanda} style={{cursor: "pointer"}} onClick={() => this.modalInfo(info.tipo_plano_sob_demanda)}></i>
                                                :
                                                    <i className="las la-info-circle" data-toggle="tooltip" data-placement="top" title={info.tipo_plano_assinatura} style={{cursor: "pointer"}} onClick={() => this.modalInfo(info.tipo_plano_assinatura)}></i>
                                            }
                                        </label>
                                    </div>
                                    <Select
                                        value={detalhes.tipo_plano}
                                        options={this.state.tipoPlano}
                                        onChange={(e) => this.handleChange("tipo_plano", e)}
                                    />
                                </div>
                            </div>
                            { detalhes.tipo_plano?.value === "assinatura" && (
                                <>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className='required'>
                                                Cobrança por
                                                &nbsp;
                                                <i className="las la-info-circle" data-toggle="tooltip" data-placement="top" title={info.cobranca_por} style={{cursor: "pointer"}} onClick={() => this.modalInfo(info.cobranca_por)}></i>
                                            </label>
                                            <Select
                                                value={detalhes.cobranca_por}
                                                options={this.state.optionsCobranca}
                                                onChange={(e) => this.handleChange("cobranca_por", e)}
                                            />
                                            <span id='validacao-cobranca_por'></span>
                                        </div>
                                        <div className="col-md-4">
                                            <label className='required' htmlFor="frequencia_cobranca">
                                                Frequência
                                                &nbsp;
                                                <i className="las la-info-circle" data-toggle="tooltip" data-placement="top" title={info.frequencia_cobranca} style={{cursor: "pointer"}} onClick={() => this.modalInfo(info.frequencia_cobranca)}></i>
                                            </label>
                                            <input
                                                type='text'
                                                value={detalhes.frequencia_cobranca}
                                                id="frequencia_cobranca"
                                                onChange={(e) => this.handleChange("frequencia_cobranca", e.target.value, true)}
                                            />
                                            <span id='validacao-valor'></span>
                                        </div>
                                        <div className="col-md-4">
                                            <label className='required' htmlFor="valor">Valor</label>
                                            <input
                                                type='text'
                                                value={detalhes.valor ?? "0,00"}
                                                id="valor"
                                                onChange={(e) => this.handleChange("valor", e.target.value, false, true)}
                                            />
                                            <span id='validacao-valor'></span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="quantidade_de_mensagem">
                                                <input 
                                                    type="checkbox"
                                                    checked={fieldsChecked?.quantidade_de_mensagem}
                                                    onChange={(e) => this.handleChangeFieldsChecked("quantidade_de_mensagem", e.target.checked)}
                                                />
                                                &nbsp;
                                                Mensagens
                                            </label>
                                            <input
                                                type='text'
                                                disabled={!fieldsChecked?.quantidade_de_mensagem}
                                                value={detalhes.quantidade_de_mensagem ?? ""}
                                                id="quantidade_de_mensagem"
                                                onChange={(e) => this.handleChange("quantidade_de_mensagem", e.target.value, true)}
                                            />
                                            <span id='validacao-quantidade_de_mensagem'></span>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="quantidade_de_dados_trafegados">
                                                <input 
                                                    type="checkbox"
                                                    checked={fieldsChecked?.quantidade_de_dados_trafegados}
                                                    onChange={(e) => this.handleChangeFieldsChecked("quantidade_de_dados_trafegados", e.target.checked)}
                                                />
                                                &nbsp;
                                                Quantidade de dados trafegados
                                                &nbsp;
                                                <i className="las la-info-circle" data-toggle="tooltip" data-placement="top" title={info.dados_trafegados} style={{cursor: "pointer"}} onClick={() => this.modalInfo(info.dados_trafegados)}></i>
                                            </label>
                                            <input
                                                type='text'
                                                disabled={!fieldsChecked?.quantidade_de_dados_trafegados}
                                                value={detalhes.quantidade_de_dados_trafegados ?? ""}
                                                id="quantidade_de_dados_trafegados"
                                                onChange={(e) => this.handleChange("quantidade_de_dados_trafegados", e.target.value, true)}
                                            />
                                            <span id='validacao-quantidade_de_dados_trafegados'></span>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="quantidade_de_dispositivo">
                                                <input 
                                                    type="checkbox"
                                                    checked={fieldsChecked?.quantidade_de_dispositivo}
                                                    onChange={(e) => this.handleChangeFieldsChecked("quantidade_de_dispositivo", e.target.checked)}
                                                />
                                                &nbsp;
                                                Dispositivos
                                            </label>
                                            <input
                                                type='text'
                                                disabled={!fieldsChecked?.quantidade_de_dispositivo}
                                                value={detalhes.quantidade_de_dispositivo ?? ""}
                                                id="quantidade_de_dispositivo"
                                                onChange={(e) => this.handleChange("quantidade_de_dispositivo", e.target.value, true)}
                                            />
                                            <span id='validacao-quantidade_de_dispositivo'></span>
                                        </div>
                                    </div>
                                </>
                            )}
                            { detalhes.tipo_plano?.value === "sob_demanda" && (
                                <> 
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="valor_mensagem">
                                                <input 
                                                    type="checkbox"
                                                    checked={fieldsChecked?.quantidade_de_mensagem}
                                                    onChange={(e) => this.handleChangeFieldsChecked("quantidade_de_mensagem", e.target.checked)}
                                                />
                                                &nbsp;
                                                Valor por quantidade de mensagem
                                            </label>
                                            <input
                                                type='text'
                                                value={detalhes.valor_mensagem ?? "R$ 0,00"}
                                                disabled={!fieldsChecked?.quantidade_de_mensagem}
                                                id="valor_mensagem"
                                                onChange={(e) => this.handleChange("valor_mensagem", e.target.value, false, true)}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="valor_dados_trafegados">
                                                <input 
                                                    type="checkbox"
                                                    checked={fieldsChecked?.quantidade_de_dados_trafegados}
                                                    onChange={(e) => this.handleChangeFieldsChecked("quantidade_de_dados_trafegados", e.target.checked)}
                                                />
                                                &nbsp;
                                                Valor por quantidade de dados trafegados
                                                &nbsp;
                                                <i className="las la-info-circle" data-toggle="tooltip" data-placement="top" title={info.dados_trafegados} style={{cursor: "pointer"}} onClick={() => this.modalInfo(info.dados_trafegados)}></i>
                                            </label>
                                            <input
                                                type='text'
                                                value={detalhes.valor_dados_trafegados ?? "R$ 0,00"}
                                                disabled={!fieldsChecked?.quantidade_de_dados_trafegados}
                                                id="valor_dados_trafegados"
                                                onChange={(e) => this.handleChange("valor_dados_trafegados", e.target.value, false, true)}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="valor_dispositivo">
                                                <input 
                                                    type="checkbox"
                                                    checked={fieldsChecked?.quantidade_de_dispositivo}
                                                    onChange={(e) => this.handleChangeFieldsChecked("quantidade_de_dispositivo", e.target.checked)}
                                                />
                                                &nbsp;
                                                Valor por quantidade de dispositivo
                                            </label>
                                            <input
                                                type='text'
                                                value={detalhes.valor_dispositivo ?? "R$ 0,00"}
                                                disabled={!fieldsChecked?.quantidade_de_dispositivo}
                                                id="valor_dispositivo"
                                                onChange={(e) => this.handleChange("valor_dispositivo", e.target.value, false, true)}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            </div>
                    </TabPanel>

                    <TabPanel>
                        <div className="hdv-form-default">
                            <div className="row align-items-end">
                                <div className="col-md-9">
                                    <label className="required">Cliente</label>
                                    <Select
                                        value={detalhes.cliente ?? null}
                                        options={this.state.optionsClientes}
                                        onChange={(e) => this.handleChange("cliente", e)}
                                        placeholder="Selecione um cliente para vincular"
                                    />
                                </div>
                                <div className="col-md-3 d-flex justify-content-center align-items-center">
                                    <button
                                        className="hdv-btn-forms hdv-btn-green"
                                        style={{ width: "100%", margin: "0px", height: "44px" }}
                                        disabled={detalhes.cliente == null}
                                        onClick={this.addCliente}
                                    >
                                        Adicionar
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <span id='validacao-cliente'></span>
                                </div>
                            </div>
                        </div>

                        <br/>
                        {
                            clientes.length === 0 ? (
                                <div className="d-flex justify-content-center align-items-center" style={{height: "100px"}}>
                                    <div>Nenhum cliente vinculado</div>
                                </div>
                            ) : (
                                <table className="table afira-table">
                                    <thead>
                                        <tr>
                                            <th>Lista de clientes</th>
                                            <th className="hdv-subtable-action-td" style={{textAlign: "center"}}>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            clientes.map((cliente, index) => {
                                                return(
                                                    <tr key={index}>
                                                        <td>{cliente.label}</td>
                                                        <td className="hdv-subtable-action-td" style={{textAlign: "center"}}> 
                                                            <ConfirmDelete
                                                                enabled={true}
                                                                action={() => this.deletarCliente(index)}
                                                                label="Remover"
                                                                style={{marginRight: "0"}}
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>   
                            )
                        }
                    </TabPanel>
                </Tabs>


                <div className="hdv-btn-group">
                    <ButtonsForm
                        route="/lns/planos"
                        edit={this.props.match.params.id ? true : false}
                        cooldown={this.state.cooldown}
                        buttons={[
                            {
                                method: "post",
                                button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                            },

                            {
                                method: "post",
                                button: <button style={{ display: this.props.match.params.id ? "none" : "inline-block" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight">Salvar e Cadastrar um Novo</button>
                            },

                            {
                                method: "patch",
                                button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                            },
                        ]}
                    />

                    <Link to="/lns/planos">
                        <button className="hdv-btn-forms hdv-btn-orange">Cancelar</button>
                    </Link>
                </div>
            </div>
        )
    }
}

export default Form